import { useEffect, useState } from "react";
import { userService } from "../../../services";

interface Creator {
  username: string;
  name: string;
}

const CreatorsProfilesPage = () => {
  const [creators, setCreators] = useState<Creator[]>([]);

  useEffect(() => {
    const fetchCreators = async () => {
      try {
        const response = await userService.getCreatorsProfiles();
        setCreators(response || []);
      } catch (error) {
        console.error("Error fetching creators:", error);
      }
    };

    fetchCreators();
  }, []);

  return (
    <nav aria-label="Creator Profiles">
      <h1 style={{ color: "white" }}>All Creators</h1>
      <ul>
        {creators.map((creator) => (
          <li key={creator.username} style={{ listStyle: "none" }}>
            <a href={`/p/${creator.username}`} title={creator.name}>
              {creator.name || creator.username}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default CreatorsProfilesPage;
